import type { PropsWithChildren } from "react";
import { Footer } from "./footer";
import { Header } from "./header";
import { StarfieldCanvas } from "../homepage/StarfieldCanvas";

export function Page({ children }: PropsWithChildren) {
  return (
    <div className="relative min-h-screen bg-transparent">
      {/* Background Canvas at z-0 */}
      <StarfieldCanvas />

      {/* Content Stacking Context at z-10 */}
      <div className="flex flex-col min-h-screen relative z-10">
        <Header />
        <div className="grow">{children}</div>
        <Footer />
      </div>
    </div>
  );
}
